/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';
import type { MediaSourceQuality } from './MediaSourceQuality';
import {
    MediaSourceQualityFromJSON,
    MediaSourceQualityFromJSONTyped,
    MediaSourceQualityToJSON,
    MediaSourceQualityToJSONTyped,
} from './MediaSourceQuality';

/**
 * 
 * @export
 * @interface PnoEntry
 */
export interface PnoEntry {
    /**
     * 
     * @type {string}
     * @memberof PnoEntry
     */
    currency?: string;
    /**
     * 
     * @type {number}
     * @memberof PnoEntry
     */
    pnoNet?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PnoEntry
     */
    pnoGross?: number | null;
    /**
     * 
     * @type {MediaSourceQuality}
     * @memberof PnoEntry
     */
    mediaSourceQuality?: MediaSourceQuality;
    /**
     * 
     * @type {PnoEntryFinanceScopeEnum}
     * @memberof PnoEntry
     */
    financeScope?: PnoEntryFinanceScopeEnum;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof PnoEntry
     */
    spendMarketing?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof PnoEntry
     */
    turnoverNet?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof PnoEntry
     */
    turnoverGross?: MoneyOutput;
}


/**
 * @export
 */
export const PnoEntryFinanceScopeEnum = {
    CanonicalSelected: 'canonical_selected'
} as const;
export type PnoEntryFinanceScopeEnum = typeof PnoEntryFinanceScopeEnum[keyof typeof PnoEntryFinanceScopeEnum];


/**
 * Check if a given object implements the PnoEntry interface.
 */
export function instanceOfPnoEntry(value: object): value is PnoEntry {
    return true;
}

export function PnoEntryFromJSON(json: any): PnoEntry {
    return PnoEntryFromJSONTyped(json, false);
}

export function PnoEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PnoEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'currency': json['currency'] == null ? undefined : json['currency'],
        'pnoNet': json['pnoNet'] === undefined ? undefined : json['pnoNet'] === null ? null : json['pnoNet'],
        'pnoGross': json['pnoGross'] === undefined ? undefined : json['pnoGross'] === null ? null : json['pnoGross'],
        'mediaSourceQuality': json['mediaSourceQuality'] == null ? undefined : MediaSourceQualityFromJSON(json['mediaSourceQuality']),
        'financeScope': json['financeScope'] == null ? undefined : json['financeScope'],
        'spendMarketing': json['spendMarketing'] == null ? undefined : MoneyOutputFromJSON(json['spendMarketing']),
        'turnoverNet': json['turnoverNet'] == null ? undefined : MoneyOutputFromJSON(json['turnoverNet']),
        'turnoverGross': json['turnoverGross'] == null ? undefined : MoneyOutputFromJSON(json['turnoverGross']),
    };
}

export function PnoEntryToJSON(json: any): PnoEntry {
    return PnoEntryToJSONTyped(json, false);
}

export function PnoEntryToJSONTyped(value?: PnoEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currency': value['currency'],
        'pnoNet': value['pnoNet'],
        'pnoGross': value['pnoGross'],
        'mediaSourceQuality': MediaSourceQualityToJSON(value['mediaSourceQuality']),
        'financeScope': value['financeScope'],
        'spendMarketing': MoneyOutputToJSON(value['spendMarketing']),
        'turnoverNet': MoneyOutputToJSON(value['turnoverNet']),
        'turnoverGross': MoneyOutputToJSON(value['turnoverGross']),
    };
}

